import { AlertContext } from 'decorators/Alert'
import { useContext } from 'react'

export const useAlert = () => useContext(AlertContext)
